<h2 mat-dialog-title>
  {{ isEdit ? 'Edit Proxy' : 'Create Proxy' }}
</h2>

<mat-dialog-content>
  <form [formGroup]="proxyForm" class="proxy-form">
    @if (isEdit) {
      <ng-container [ngTemplateOutlet]="singleProxyFields"></ng-container>
    } @else {
      <mat-tab-group
        class="create-tabs"
        mat-stretch-tabs="false"
        [(selectedIndex)]="selectedCreateTabIndex">
        <mat-tab label="Single">
          <div class="tab-panel">
            <ng-container [ngTemplateOutlet]="singleProxyFields"></ng-container>
          </div>
        </mat-tab>

        <mat-tab label="Bulk">
          <div class="tab-panel">
            <mat-form-field appearance="outline" class="full-width">
              <mat-label>Bulk Proxies</mat-label>
              <textarea
                matInput
                rows="10"
                formControlName="bulkText">
              </textarea>

              <mat-hint>
                Paste one proxy per line in the format:
                username:password&#64;ip:port
              </mat-hint>
            </mat-form-field>
          </div>
        </mat-tab>
      </mat-tab-group>
    }
  </form>
</mat-dialog-content>

<ng-template #singleProxyFields>
  <div [formGroup]="proxyForm" class="single-proxy-fields">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Address</mat-label>
      <input
        matInput
        formControlName="address"
        placeholder="Proxy address" />

      @if (proxyForm.controls.address.hasError('required')) {
        <mat-error>Address is required</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Port</mat-label>
      <input
        matInput
        type="number"
        formControlName="port"
        placeholder="50100" />

      @if (proxyForm.controls.port.hasError('required')) {
        <mat-error>Port is required</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Username</mat-label>
      <input
        matInput
        formControlName="username"
        placeholder="Username" />

      @if (proxyForm.controls.username.hasError('required')) {
        <mat-error>Username is required</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Password</mat-label>
      <input
        matInput
        formControlName="password"
        placeholder="Password" />

      @if (proxyForm.controls.password.hasError('required')) {
        <mat-error>Password is required</mat-error>
      }
    </mat-form-field>

    <div class="toggle-row">
      <mat-slide-toggle formControlName="active">
        Active
      </mat-slide-toggle>
    </div>
  </div>
</ng-template>

<mat-dialog-actions align="end">
  <button
    mat-button
    (click)="cancel()"
    [disabled]="loading">
    Cancel
  </button>

  <button
    mat-raised-button
    color="primary"
    (click)="submit()"
    [disabled]="loading">

    {{
      isEdit
        ? 'Update'
        : selectedCreateTabIndex === 1
          ? 'Import Proxies'
          : 'Create'
    }}

  </button>
</mat-dialog-actions>
